export const CANNED_REPORTS = [
  {
    key: "1",
    name: "High Lead Time",
    slug: "high-lead-time",
    description: "All line items sorted from highest to lowest lead time",
  },
  {
    key: "2",
    name: "Subcontractor Health",
    slug: "subcontractor-health",
    description:
      "A comparison showing if subs deliver on time, late, or early",
  },
  {
    key: "3",
    name: "Item Deficiencies",
    slug: "item-deficiencies",
    description: "All line items with missing fields",
  },
  {
    key: "4",
    name: "Design Team Review Time",
    slug: "design-team-review-time",
    description:
      "A comparison showing if the design team returns submittals on time, late, or early",
  },
  {
    key: "5",
    name: "Submittal Issuance Review",
    slug: "submittal-issuing-review",
    description:
      "A comparison showing if submittals are issued on time, late, or early",
  },
  {
    key: "6",
    name: "Subcontracts Issued",
    slug: "subcontract-signing",
    description:
      "A comparison showing if commitments are issued on time, late, or early",
  },
  {
    key: "7",
    name: "Upcoming Deliveries",
    slug: "upcoming-deliveries",
    description: "Items due on site within 30 days",
  },
  {
    key: "8",
    name: "Planned Submittal Issue Date",
    slug: "planned-issue-date",
    description:
      "Editable report to provide Architect with planned dates for submittal issuance",
  },
  {
    key: "9",
    name: "OPC Milestones",
    slug: "activity-finish",
    description:
      "A report that enables schedulers to easily update OPC with constraint dates for when material is available.",
  },
  {
    key: "10",
    name: "Workflow Stage",
    slug: "workflow-stage",
    description: "A report that shows current workflow and it's due date.",
  },
  {
    key: "11",
    name: "Submittal Submission Schedule",
    slug: "submittal-submission-schedule",
    description:
      "A comprehensive report depicting when submittals are expected to be submitted to the design team",
  },
  {
    key: "12",
    name: "Submittals Last Updated Time",
    slug: "submittals-last-updated-time",
    description:
      "Submittals filtered and sorted by the date and time they were last updated",
  },
];

const CANNED_REPORT_NAME_BY_SLUG = CANNED_REPORTS.reduce((acc, report) => {
  acc[report.slug] = report.name;
  return acc;
}, {});

function normalizeReportName(value) {
  return String(value || "").trim().toLowerCase();
}

export function normalizeReportAccessLevel(value) {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
}

export function parseCannedReportsGranularPermission(value) {
  return new Set(
    String(value || "")
      .split(",")
      .map((item) => normalizeReportName(item))
      .filter(Boolean),
  );
}

export function getCannedReportNameFromSlug(slug) {
  return CANNED_REPORT_NAME_BY_SLUG[slug] || "";
}

export function canAccessCannedReport({
  accessLevel,
  allowedReports,
  reportName,
  reportSlug,
}) {
  const normalizedAccessLevel = normalizeReportAccessLevel(accessLevel);

  if (normalizedAccessLevel > 1) {
    return true;
  }

  if (normalizedAccessLevel !== 1) {
    return false;
  }

  const resolvedReportName =
    reportName || getCannedReportNameFromSlug(reportSlug) || "";

  return allowedReports.has(normalizeReportName(resolvedReportName));
}
